import { render, staticRenderFns } from "./inspectionTaskForm.vue?vue&type=template&id=bbbd6f54&scoped=true&"
import script from "./inspectionTaskForm.vue?vue&type=script&lang=js&"
export * from "./inspectionTaskForm.vue?vue&type=script&lang=js&"
import style0 from "./inspectionTaskForm.vue?vue&type=style&index=0&id=bbbd6f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbd6f54",
  null
  
)

export default component.exports